import LanguageLinks from "@components/SiteShell/LanguageLinks";
import { Button } from "@justhome/react-ui";
import useLanguage from "@lib/hooks/useLanguage";
import { appendHrefSuffix } from "@lib/routing";
import { useRouter } from "@lib/hooks/useRouter";
import { FC } from "react";

interface MinimalHeaderNavProps {
  onContactClick?: VoidFunction;
}

const MinimalHeaderNav: FC<MinimalHeaderNavProps> = ({ onContactClick }) => {
  const { asPath } = useRouter();
  const language = useLanguage();
  const pathname = asPath.split(/[?#]/)[0] ?? "/";
  const suffix = asPath.slice(pathname.length);

  return (
    <nav className="flex gap-3xs items-center ml-auto">
      <LanguageLinks
        language={language}
        alternateLanguageHref={appendHrefSuffix(
          language === "de"
            ? `/en${pathname === "/" ? "" : pathname}`
            : pathname,
          suffix,
        )}
      />
      {onContactClick && (
        <Button variant="primary" size="sm" onClick={onContactClick}>
          <span className="hidden s:block">Kostenfrei beraten lassen</span>
          <span className="s:hidden">Beratung</span>
        </Button>
      )}
    </nav>
  );
};

export default MinimalHeaderNav;
